import React, {useEffect, useState} from "react";
import {Card, Col, message, Row} from "antd";
import {getHostAddress,getFileAddress,getFrontEndAddress} from "../../Tool/UtileFun";
import cookie from "react-cookies";
import { Typography } from 'antd';

export function NewCardIMGPage(){


    useEffect(
        ()=>{
            findExperimentAll()
            //findByTeacherExperiment()
        },[]
    );

    const { Title } = Typography;
    const classId = "classID"
    const { Meta } = Card;
    const [cardData,setCardData] = useState([]);

    const findExperimentAll=()=>{
        fetch(
            "http://"+getHostAddress()+"/experiment/findByUserCLassId",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({classId:cookie.load(classId)}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setCardData(data)
                console.log(data)
            })
            .catch(error => message.error("error"+error));
    }

    //findByTeacherExperiment
    const userId = "userId"
    const findByTeacherExperiment=()=>{
        fetch(
            "http://"+getHostAddress()+"/experiment/findByTeacherExperiment",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({userId:cookie.load(userId)}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setCardData(data)
                console.log(data)
            })
            .catch(error => message.error("error"+error));
    }



    const experimentID = "experimentID"
    const experimentInfo = value =>{
        //todo
        cookie.save(experimentID,value.id)
        window.open("http://"+getFrontEndAddress()+"/user/videoAndOtherFile")
    }


    const imgData = (
        <>
            {/*<Row>*/}
            {/*    <Col span={6} >*/}

            {/*    </Col>*/}
            {/*    <Col span={1} >*/}

            {/*    </Col>*/}
            {/*    <Col span={12} >*/}
            {/*        <Title level={3}>RPA审计机器人课程平台</Title>*/}
            {/*    </Col>*/}
            {/*    <Col span={6} >*/}

            {/*    </Col>*/}
            {/*</Row>*/}
            <Row gutter={[24,24]}>
                {
                    cardData.map(
                        card=>
                            <Col>
                                <Card
                                    hoverable
                                    style={{ width: 250}}
                                    onClick={()=>experimentInfo(card)}
                                    cover={<img style={{height :180 }}
                                                alt={card.target}
                                                src={card.relativeAddress} />}
                                >
                                    {/*description="共2节"*/}
                                    <Meta title={card.target} />
                                </Card>
                            </Col>
                    )
                }
            </Row>
        </>
    )

    return(
        <>
            {imgData}
        </>
    )

}
